var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-home-case"},[_c('div',{style:({
        'background-image': 'url(' + _vm.data.bg + ')',
        'width': '100%',
        'height': '100vh',
        'background-size': 'cover'
    })}),_vm._v(" "),_c('div',{staticClass:"cp-home-case-content"},[_c('div',{class:[
          'cp-home-follow-ani-start',
          _vm.isRender ? 'cp-home-follow-ani-1' : ''
        ]},[_c('div',{staticClass:"cp-home-case-title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"cp-home-case-text"},[_vm._v(_vm._s(_vm.data.text))])]),_vm._v(" "),_c('div',{class:[
          'cp-home-follow-ani-start',
          _vm.isRender ? 'cp-home-follow-ani-2' : ''
        ]},[_c('img',{staticClass:"cp-home-case-qrcode",attrs:{"src":_vm.data.qrcode}}),_vm._v(" "),_vm._l((_vm.data.tip),function(item,i){return _c('div',{staticClass:"cp-home-case-tip"},[_vm._v(_vm._s(item))])})],2),_vm._v(" "),_c('div',{class:[
            'cp-home-case-recode',
            'cp-home-follow-ani-start',
            _vm.isRender ? 'cp-home-follow-ani-3' : ''
          ]},_vm._l((_vm.data.recode),function(item,i){return _c('span',{staticStyle:{"margin-right":".1rem","display":"inline-block"}},[_vm._v(_vm._s(item))])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a628f92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Follow.vue
// module id = null
// module chunks = 